import values from 'mout/object/values'
import getSubtest from "./getSubtest";
import sortByPropText from "../content/manageSets/sortByPropText";
import checkRating from './checkRating';

export default function getPrecisionRating(userAssessment) {

  const ratingThresholds = {
    'Math': [
      {percent: 100, rating: 5},
      {percent: 90, rating: 4},
      {percent: 80, rating: 3},
      {percent: 70, rating: 2},
      {percent: 69, rating: 1},
    ]
  }

  function findPrecisionItemNumbers(userAssessment) {
    const subtest = getSubtest('Math', userAssessment)
    const { precisionQuestions, precisionComparables} = subtest
    return {
      precisionQuestions,
      precisionComparables
    }
  }

  function mapItems(items, byItem) {
    if (!items) {
      items = []
    }
    const byItemList = sortByPropText(values(byItem), 'index')
    return items.map(function findPercent(item) {
      if (byItemList[item - 1]) {
        if (byItemList[item - 1].possible) {
          return byItemList[item - 1].raw / byItemList[item - 1].possible
        } else {
          return 0
        }
      }
    })
  }

  function addArray(arr) {
    return arr.reduce((a, b) => a + b, 0)
  }

  function averageArray(arr) {
    return addArray(arr) / arr.length
  }

  function averagePrecisionItems(userAssessment) {
    const precisionItems = findPrecisionItemNumbers(userAssessment)
    const subtest = getSubtest('Math', userAssessment)
    const subtestId = subtest.setId
    const byItem = userAssessment.scoring.byItem[subtestId]
    return {
      precisionQuestions: averageArray(mapItems(precisionItems.precisionQuestions, byItem)),
      precisionComparables: averageArray(mapItems(precisionItems.precisionComparables, byItem)),
    }
  }
  
  function getPrecisionRating(userAssessment) {
    const pData = averagePrecisionItems(userAssessment)
    const score = pData.precisionQuestions / pData.precisionComparables * 100
    const ratingTest = (r, score) => score > r.percent
    return checkRating(ratingThresholds, 'Math', score, ratingTest)
  }

  const precItemNumbers = findPrecisionItemNumbers(userAssessment).precisionQuestions
  const preciseItems = precItemNumbers ? precItemNumbers.map(num => parseInt(num, 10)) : []

  return {
    stars: getPrecisionRating(userAssessment),
    preciseItems,
  }
}

/*

PRECISION
PrecisionQuestions: 2,3,10,12,27,32,34,40,49,51,53,55,60
PrecisionComparables: 5,9,11,17,23,30,36,39,50,52,54,56,57
Compares precision labeled questions with comparables that don't require precision in front 45.
5: >100%
4: >90%
3: >80%
2: >70%
1: <=70%
*/


// WEBPACK FOOTER //
// ./src/helpers/assessment/getPrecisionRating.js